<template>
    <template v-if="students">
        <template v-if="!onlyOneStudent">
            <div class="mt-4 mb-8">
                <DField
                    id="students"
                    label="Students"
                    required
                    required-color="text-red-600"
                    :form-errors="errors"
                >
                    <DCheckbox
                        v-for="student in students"
                        :key="student.external_id"
                        v-model="selectedStudents[student.external_id]"
                        card
                        checkbox-position="right"
                    >
                        <template #icon>
                            <UIAvatar
                                :avatar="student.avatar"
                                size-override="medium-small"
                            />
                        </template>
                        {{ student.avatar.description }}
                    </DCheckbox>
                </DField>
            </div>
        </template>
        <template v-else>
            <div class="w-full flex items-center pt-4 mb-8">
                <UIAvatar
                    :avatar="students[0].avatar"
                    size-override="medium-small"
                />
                <div class="ml-2">
                    <div class="content-sm-ux-medium text-neutral-base">
                        {{ students[0].avatar.description }}
                    </div>
                </div>
            </div>
        </template>
    </template>
</template>

<script setup>
    import { DCheckbox, DField } from '@digistorm/spark'
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const emit = defineEmits(['change'])

    const props = defineProps({
        students: Array,
        errors: Array,
    })

    const selectedStudents = ref({})

    const onlyOneStudent = computed(() => {
        return props.students.length === 1
    })

    const toggleStudent = (student) => {
        selectedStudents.value[student.external_id] = !selectedStudents.value[student.external_id]
    }

    const selectedStudentIds = computed(() => {
        return transform(selectedStudents.value, (selected, studentIsSelected, studentId) => {
            if (studentIsSelected) {
                selected.push(studentId)
            }
        }, [])
    })

    onMounted(() => {
        if (onlyOneStudent.value) {
            toggleStudent(props.students[0])
        }
    })

    watch(selectedStudentIds, (val) => {
        emit('change', val)
    }, {
        deep: true,
    })
</script>
